/**
 * Created by Karol Kluska on 15.09.17.
 */

angular
  .module('app')
  .factory('SettingService', SettingService);

function SettingService(Restangular) {
  function getHotelConfig(customerId, hotelId, langCode) {
    /* eslint-disable camelcase */
    var requestParams = {
      userid: customerId,
      hotelid: hotelId,
      language: langCode
    };

    /* eslint-enable camelcase */
    return Restangular.one('bookingengine/api/be/hotelconfig').get(requestParams)
      .then(function (result) {
        return result;
      })
      .catch(function () {
        return null;
      });
  }

  function getBookingEngineConfig(customerId, hotelId, langCode) {
    /* eslint-disable camelcase */
    var requestParams = {
      user_id: customerId,
      hotel_id: hotelId,
      language: langCode
    };
    /* eslint-enable camelcase */
    return Restangular.one('bookingengine/api/be/hotels/' + requestParams.hotel_id + '/beconfig').get(requestParams)
      .then(function (result) {
        return result;
      })
      .catch(function () {
        return null;
      });
  }

  function getRoomGroupCategoryFilters(hotelId) {
    return Restangular.all('bookingengine/api/be/hotels/' + hotelId + '/roomgroupcategoryfilters').getList()
      .then(function (result) {
        return result;
      })
      .catch(function () {
        return null;
      });
  }

  function getCategoriesList(customerId, hotelId, langCode) {
    /* eslint-disable camelcase */
    var requestParams = {
      user_id: customerId,
      hotel_id: hotelId,
      language: langCode
    };
    /* eslint-enable camelcase */
    return Restangular.all('bookingengine/api/be/hotels/' + requestParams.hotel_id + '/roomgroups').getList(requestParams)
      .then(function (result) {
        return result;
      })
      .catch(function () {
        return null;
      });
  }

  function getCustomerCss(customerId, hotelId) {
    /* eslint-disable camelcase */
    var requestParams = {
      userid: customerId,
      hotelid: hotelId
    };
    /* eslint-enable camelcase */
    return Restangular.one('bookingengine/api/be/hotels/' + hotelId + '/css').get(requestParams)
      .then(function (result) {
        return result;
      })
      .catch(function () {
        return null;
      });
  }

  return {
    getHotelConfig: getHotelConfig,
    getBookingEngineConfig: getBookingEngineConfig,
    getCategoriesList: getCategoriesList,
    getRoomGroupCategoryFilters: getRoomGroupCategoryFilters,
    getCustomerCss: getCustomerCss
  };
}
